import React from "react";

const StartFromScratch = ({ hover }: { hover?: boolean }) => {

  if (hover) {
    return (
      <svg width="148" height="71" viewBox="0 0 148 71" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g filter="url(#filter0_d_15240_14628)">
      <rect opacity="0.5" x="48.35" y="6.35" width="56.3" height="39.3" rx="3.65" fill="#F7F9FC" stroke="#9EA7B6" stroke-width="0.7" stroke-dasharray="2 1"/>
      <rect x="43.5" y="11.5" width="56" height="39" rx="4.5" fill="#F7F9FC" stroke="#9EA7B6"/>
      <rect x="43" y="53" width="45" height="3" rx="1.5" fill="#DADEE6"/>
      <rect x="43" y="58" width="34.7091" height="3" rx="1.5" fill="#DADEE6"/>
      <circle cx="72.0999" cy="31.0999" r="10.0999" fill="#DADEE6"/>
      <rect x="71.2583" y="25.2095" width="1.68332" height="11.7832" rx="0.84166" fill="#1879B9"/>
      <rect x="66.209" y="31.9424" width="1.68332" height="11.7832" rx="0.84166" transform="rotate(-90 66.209 31.9424)" fill="#1879B9"/>
      </g>
      <defs>
      <filter id="filter0_d_15240_14628" x="35" y="0" width="78" height="71" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
      <feFlood flood-opacity="0" result="BackgroundImageFix"/>
      <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
      <feOffset dy="2"/>
      <feGaussianBlur stdDeviation="4"/>
      <feColorMatrix type="matrix" values="0 0 0 0 0.415686 0 0 0 0 0.45098 0 0 0 0 0.505882 0 0 0 0.12 0"/>
      <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_15240_14628"/>
      <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_15240_14628" result="shape"/>
      </filter>
      </defs>
      </svg>
      
    );
  }

  return (
    <svg width="148" height="71" viewBox="0 0 148 71" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g filter="url(#filter0_d_15240_14611)">
    <rect opacity="0.5" x="48.35" y="6.35" width="56.3" height="39.3" rx="3.65" fill="#F7F9FC" stroke="#9EA7B6" stroke-width="0.7" stroke-dasharray="2 1"/>
    <rect x="43.5" y="11.5" width="56" height="39" rx="4.5" fill="#F7F9FC" stroke="#9EA7B6"/>
    <rect x="43" y="53" width="45" height="3" rx="1.5" fill="#DADEE6"/>
    <rect x="43" y="58" width="34.7091" height="3" rx="1.5" fill="#DADEE6"/>
    <circle cx="72.0999" cy="31.0999" r="10.0999" fill="#DADEE6"/>
    <rect x="71.2583" y="25.2095" width="1.68332" height="11.7832" rx="0.84166" fill="#9EA7B6"/>
    <rect x="66.209" y="31.9424" width="1.68332" height="11.7832" rx="0.84166" transform="rotate(-90 66.209 31.9424)" fill="#9EA7B6"/>
    </g>
    <defs>
    <filter id="filter0_d_15240_14611" x="-8" y="0" width="164" height="71" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
    <feFlood flood-opacity="0" result="BackgroundImageFix"/>
    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
    <feOffset dy="2"/>
    <feGaussianBlur stdDeviation="4"/>
    <feColorMatrix type="matrix" values="0 0 0 0 0.415686 0 0 0 0 0.45098 0 0 0 0 0.505882 0 0 0 0.12 0"/>
    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_15240_14611"/>
    <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_15240_14611" result="shape"/>
    </filter>
    </defs>
    </svg>
    

  );
};

export default StartFromScratch;
